import React from 'react'
import {
  Direction,
  DragDropContext,
  Draggable,
  DroppableProvided,
  DropResult as DropResultType,
  OnDragEndResponder,
} from 'react-beautiful-dnd'

import StrictModeDroppable from './StrictModeDroppable'

export type DropResult = DropResultType

export const reorder = (
  list: Iterable<unknown> | ArrayLike<unknown>,
  startIndex: number,
  endIndex: number
) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)
  return result
}

export type DraggableContainerItem = {
  id: string
  content: React.ReactNode
}

export type DraggableContainerProps = {
  items: DraggableContainerItem[]
  direction: Direction
  onDragEnd: OnDragEndResponder
}

const DraggableContainer = ({ items, direction, onDragEnd }: DraggableContainerProps) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <StrictModeDroppable droppableId="droppable" direction={direction}>
        {(provided: DroppableProvided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            style={{
              display: 'flex',
              flexDirection: direction === 'horizontal' ? 'row' : 'column',
              overflow: 'auto',
            }}
          >
            {items.map((item, index) => (
              <Draggable
                key={item.id}
                draggableId={item.id}
                index={index}
                disableInteractiveElementBlocking
              >
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={{
                      userSelect: 'none',
                      ...provided.draggableProps.style,
                    }}
                  >
                    {item.content}
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </StrictModeDroppable>
    </DragDropContext>
  )
}

DraggableContainer.displayName = 'DraggableContainer'

export default DraggableContainer
